import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/subscription-transaction"

export const PaymentTransactionLogsList = async (values) => {
    return await axiosInstance(options).post(`${path}/transaction-logs`, values);
}

export const ManualActivateSubscription = async (values) => {
    return await axiosInstance(options).post(`${path}/manual-activate`, values);
}
